/**
 * Returns two-letter language code from full locale.
 */
export const getLanguageFromLocale = (
  locale: Intl.UnicodeBCP47LocaleIdentifier
) => {
  try {
    return new Intl.Locale(locale).language;
  } catch (_err: unknown) {
    return null;
  }
};
